import { toRefs, computed, ref } from '#imports';
import type { CheckProps as Props } from '@/shared/interfaces';
import isEqual from '@/shared/utils/is-equal';

export default (props: Props<unknown, unknown>, emit: any) => {
	const {
		modelValue,
		value,
		required,
		disabled,
		isError,
		checked,
	} = toRefs(props);

	const isModelArray = computed(() => {
		return Array.isArray(modelValue.value);
	});

	const isValueObject = computed(() => {
		return value.value !== null && typeof value.value === 'object';
	});

	const isSelected = computed(() => {
		if (Array.isArray(modelValue.value)) {
			if (isValueObject.value) {
				return modelValue.value.some(
					(obj: any) => (isEqual(obj.value, value.value)),
				);
			} else {
				return modelValue.value.includes(value);
			}
		}

		if (isValueObject.value) {
			return isEqual(modelValue.value, value.value);
		}

		return modelValue.value === value.value;
	});

	const removeValueFromModel = (newModel: any) => {
		if (isValueObject.value) {
			newModel = newModel.filter(
				(obj: Record<string, unknown>) => (!isEqual(obj.value, value.value)),
			);
		} else {
			const index = newModel.indexOf(value);

			if (~index) {
				newModel.splice(index, 1);
			}
		}

		emit('update:modelValue', newModel);
	};

	const addValueToModel = (newModel: any) => {
		newModel.push(value);

		emit('update:modelValue', newModel);
	};

	const handleArrayCheckbox = () => {
		const newModel = modelValue.value;

		if (!isSelected.value) {
			addValueToModel(newModel);
		} else {
			removeValueFromModel(newModel);
		}
	};

	const isFocused = ref(false);

	const computedClass = computed(() => ({
		'field--error': isError?.value,
		'field--required': required?.value,
		'field--disabled': disabled?.value,
		'field--checked': isSelected.value || checked?.value,
		'field--focused': isFocused.value,
	}));

	const handleInput = () => {
		if (disabled?.value) return;

		if (isModelArray.value) {
			handleArrayCheckbox();
		} else {
			emit('update:modelValue', isSelected.value ? false : value.value);
		}
	};

	return {
		isFocused,
		isSelected,
		computedClass,
		handleInput,
	};
};
